<template>

    <div class="plan">

      <div class="icon">
        <span class="fa-stack">
          <i class="fas fa-circle fa-stack-2x"></i>
          <i class="fas fa-book-user fa-stack-1x fa-inverse"></i>
        </span>
      </div>

      <div class="message">
        <h5>
          Your current subscription plan is <strong>{{name}} - {{cost}} per {{frequency}}.</strong>
        </h5>

        <p class="man pan smaller">
          We will be in touch if your subscription payment amount needs to change as a result of new bookings
        </p>

      </div>
    </div>


</template>

<script>
import { formatMoney } from '../../../utilities/helpers';

export default {
  name: 'ParentSubscriptionDetailsOnPaymentForm',
  props: {
    plan: {
      required: true,
      type: Object,
    },
  },
  computed: {
    name() {
      return this.plan.name;
    },
    cost() {
      return formatMoney(this.plan.cost);
    },
    frequency() {
      return this.plan.frequency;
    },
  },

};
</script>

<style lang="scss">

.icon {
  margin: 0 auto;
  text-align: center;
  align-items: center;
}


.plan {
  display: grid;
  grid-template-columns: 64px 1fr;
  margin-bottom: 8px;
  border-radius: 8px;
  align-items: center;
  color: #666;
  .fa-circle, strong {
    color: #03b5da;
  }

  .fa-book-user {
    color: #fff;
  }

  h5 {
    color: #666;
    display: grid;
    grid-template-rows: 1fr;
  }
}




.title h5 {
  color: #666;
}

.price {
  display: grid;
  grid-template-columns: minmax(100px, 1fr) 16px minmax(100px, 1fr);
  color: #888;

  .cost {
    color: #666;
  }

}

</style>
